<app-slideshow-item [item]="currentItem()" />
